import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import ReactPaginate from "react-paginate";

type Meter = {
  manufacturer: string;
  address: string;
  version: string;
  type: string;
};

type TableProps = {
  selectedFilters: Meter[];
};

export function MeterWhiteListTable({ selectedFilters }: TableProps) {
  const intl = useIntl();
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 8;

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = selectedFilters.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(selectedFilters.length / itemsPerPage);

  const handlePageChange = (selected: { selected: number }) => {
    setCurrentPage(selected.selected);
  };

  useEffect(() => {
    console.log("mdaush", selectedFilters);
  }, [selectedFilters]);

  return (
    <div>
      <table style={{ marginTop: "2rem", marginBottom: "3rem", width: "100%" }}>
        <thead>
          <tr>
            {["manufacturer", "address", "version", "type"].map((it) => (
              <th
                key={it}
                style={{
                  textTransform: "uppercase",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                {intl.messages[it]?.toString() ?? it}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {selectedFilters.length > 0 ? (
            currentItems.map((meter, i) => (
              <tr key={i}>
                <td style={{ padding: "8px" }}>
                  {meter.manufacturer || "No data"}
                </td>
                <td style={{ padding: "8px" }}>{meter.address || "No data"}</td>
                <td style={{ padding: "8px" }}>{meter.version || "No data"}</td>
                <td style={{ padding: "8px" }}>{meter.type || "No data"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} style={{ textAlign: "center", padding: "8px" }}>
                No filters available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          paddingTop: "1rem",
        }}
      >
        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          pageCount={totalPages}
          onPageChange={handlePageChange}
          breakLabel={"..."}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          containerClassName={"d-flex flex-row m-0 p-0 pointer"}
          activeClassName={"bold ml-2 mr-2 pointer"}
          pageClassName={"text ml-2 mr-2 pointer"}
          previousClassName={"text ml-2 mr-2 pointer"}
          nextClassName={"text ml-2 mr-2 pointer"}
        />
      </div>
    </div>
  );
}
